import React, {useState} from 'react';
import 'contents/assets/scss/page/mypage.scss'
import Paging from '../../../component/Inc/Paging';
import PopRequestPoint from '../_PopRequestPoint';
import PopPolicyPoint from '../_PopPolicyPoint';

function EmployeePoint() {
  const [modalOpen, setModalOpen] = useState(false);
  const [modalPolicyOpen, setModalPolicyOpen] = useState(false);
  return (
    <main className="com_container p_employee_point">
      <div className="com_center_wrap">
        <section className="com_tit_wrap">
          <h2 className='com_pg_tit icon menu12_15'>포인트 내역 <span className="bar"/><span className="point_txt">최교사103ㆍ수학</span></h2>
          <div className="com_btn_wrap">
            <button onClick={() => setModalPolicyOpen(true)} className="com_btn orange s btn_plus">포인트 정책</button>
            <button onClick={() => setModalOpen(true)} className="com_btn orange s btn_plus">포인트 요청</button>
          </div>
        </section>
        <section className="com_pg_container">
          <section className="box">
            <div className='com_board_list__top'>
              <p className="com_pg_tit">2025.08.25 입사</p>
              <button className="com_btn black s">진급 대상자</button>
            </div>
            <table className='com_board_list'>
              <colgroup>
                <col width="5%"/><col width="8%"/>
                <col width="8%"/><col width="9%"/>
                <col width="15%"/><col width="7%"/>
                <col width="7%"/><col width="7%"/>
                <col width="7%"/><col width="7%"/>
                <col width="7%"/><col width="12%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th><th>요청일</th>
                  <th>요청자</th><th>요청항목</th>
                  <th>요청내용</th><th>요청포인트</th>
                  <th>총 지급P</th><th>보유P</th>
                  <th>진급P</th><th>진급가점</th>
                  <th>필요가점</th><th>상태</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>20</td>
                  <td className='td_date'>2022.08.25</td>
                  <td>김길동111</td>
                  <td>교재제작검토</td>
                  <td>8월 초타오류 검수</td>
                  <td className='td_point'>+53</td>
                  <td>23</td>
                  <td>23</td>
                  <td>23</td>
                  <td>23</td>
                  <td>-</td>
                  <td className='td_red'>승인불가<br />2025.8.30</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className='td_date'>2022.08.25</td>
                      <td>김길동111</td>
                      <td>교재제작검토</td>
                      <td>8월 초타오류 검수</td>
                      <td className='td_red'>-20</td>
                      <td>23</td>
                      <td>23</td>
                      <td>23</td>
                      <td>23</td>
                      <td>-</td>
                      <td className='td_point'>승인<br />2025.8.30</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <Paging />
          </section>
          <section className="box">
            <div className="detail_tit dot">포인트 사용 내역</div>
            <table className='com_board_list'>
              <tbody>
                <tr>
                  <th>총 포인트</th>
                  <td className='td_point'>6,234,434</td>
                  <th>현 보유 포인트</th>
                  <td className='td_point'>122,233</td>
                </tr>
              </tbody>
            </table>
            <table className='com_board_list'>
              <colgroup>
                <col width="5%"/><col width="10%"/>
                <col width="9%"/><col width="9%"/>
                <col width="9%"/><col width="10%"/>
              </colgroup>
              <thead>
                <tr>
                  <th>No.</th>
                  <th>변경일</th>
                  <th>요청자</th>
                  <th>요청내용</th>
                  <th>등록</th>
                  <th>보유포인트</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>20</td>
                  <td className='td_date'>2022.08.25</td>
                  <td>김길동111</td>
                  <td>교재제작검토</td>
                  <td className='td_red'>-20</td>
                  <td>600</td>
                </tr>
                {[1,2,3,4,5,6,7,8,9,10].map((i,idx) => {
                  return (
                    <tr key={idx}>
                      <td>{10 - idx}</td>
                      <td className='td_date'>2022.08.25</td>
                      <td>김길동111</td>
                      <td>제안채택</td>
                      <td className='td_point'>+53</td>
                      <td>600</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
            <table className='com_board_list type_row'>
              <colgroup>
                <col width="35%"/><col />
              </colgroup>
              <tbody>
                <tr>
                  <th>요청일 / 요청자</th>
                  <td>2023. 01. 12 <button className="name btn_link">홍요청103</button></td>
                </tr>
                <tr>
                  <th>요청 포인트</th>
                  <td className='td_point'>+23</td>
                </tr>
                <tr>
                  <th>요청 사유 / 상세</th>
                  <td>8월초 교재 오류 검수</td>
                </tr>
                <tr>
                  <th>메모</th>
                  <td>평소에 열심히 했습니다..</td>
                </tr>
              </tbody>
            </table>
            <table className='com_board_list type_row'>
              <colgroup>
                <col width="35%"/><col />
              </colgroup>
              <tbody>
                <tr>
                  <th>승인일 / 승인자</th>
                  <td>2023. 01. 12 <button className="name btn_link">홍승인103</button></td>
                </tr>
                <tr>
                  <th>승인 결과</th>
                  <td className='td_point'>승인</td>
                </tr>
                <tr>
                  <th>승인 내용</th>
                  <td>승인이 불가능 합니다.</td>
                </tr>
              </tbody>
            </table>
            <div className="com_input_wrap">
              <div className="sec_input select_box">
                <select className="select">
                  <option value="승인불가">승인불가</option>
                  <option value="승인">승인</option>
                </select>
              </div>
            </div>
            <textarea className="textarea" placeholder="내용 입력"></textarea>
            <div className="com_btn_wrap center bottom">
              <button className="com_btn orange xs">승인</button>
            </div>
          </section>
        </section>
      </div>
      <PopRequestPoint open={modalOpen} close={() => setModalOpen(false)} />
      <PopPolicyPoint open={modalPolicyOpen} close={() => setModalPolicyOpen(false)} />
    </main>
  );
}

export default EmployeePoint;
